<template>
  <base-material-card
    color="primary"
    icon="mdi-cash-multiple"
    inline
    class="px-5 py-5"
  >
    <template v-slot:after-heading>
      <div class="display-1 font-weight-light">
        Adicionar Liquidação da CJI3
      </div>
    </template>

    <v-form class="pt-5">
      <v-row align="center" no-gutters class="mx-4">
        <v-col cols="12">
          <validation-provider v-slot="{ errors }" rules="required">
            <v-text-field
              id="titulo-liquidacao-cji3"
              label="Título"
              outlined
              :error-messages="errors"
              v-model="titulo"
            />
          </validation-provider>
        </v-col>
      </v-row>

      <v-row align="center" no-gutters class="mx-4">
        <v-col cols="12">
          <validation-provider v-slot="{ errors }" rules="required">
            <v-textarea
              id="codigos-obra-liquidacao-cji3"
              v-model="codigosObra"
              label="Códigos de Obra"
              outlined
              :error-messages="errors.length > 0 ? errors : codigosError"
              hint="Digite um código por linha"
              persistent-hint
              rows="4"
            />
          </validation-provider>
        </v-col>
      </v-row>

      <v-row v-if="showValidationError" class="mx-4">
        <v-col cols="12">
          <v-alert
            type="error"
            dense
            outlined
          >
            É necessário preencher o campo Códigos de Obra
          </v-alert>
        </v-col>
      </v-row>
    </v-form>
  </base-material-card>
</template>

<script>

export default {

  name: 'ParametrosLiquidacaoCji3',

  data() {
    return {
      titulo: '',
      codigosObra: '',
      showValidationError: false,
      codigosError: []
    };
  },

  watch: {
    titulo() {
      this.notifyValidationChange();
    },
    codigosObra() {
      this.validateCodigos();
      this.notifyValidationChange();
    }
  },

  mounted() {
    // Notifica o estado inicial após montar
    this.$nextTick(() => {
      this.notifyValidationChange();
    });
  },

  methods: {
    notifyValidationChange() {
      this.$nextTick(() => {
        const isValid = this.validate();
        this.$emit('validation-change', isValid);
      });
    },
    
    exportData() {
      const hasCodigos = !!this.codigosObra && this.codigosObra.trim().length > 0;

      if (!hasCodigos) {
        this.showValidationError = true;
        throw new Error('É necessário preencher o campo Códigos de Obra');
      }

      this.showValidationError = false;

      const codigosArray = this.codigosObra
        .split('\n')
        .map(codigo => codigo.trim())
        .filter(codigo => codigo.length > 0);

      return {
        nome: this.titulo,
        codigos_obra: codigosArray
      };
    },

    validateCodigos() {
      const hasCodigos = !!this.codigosObra && this.codigosObra.trim().length > 0;
      
      if (!hasCodigos) {
        this.codigosError = ['É necessário preencher o campo Códigos de Obra'];
        this.showValidationError = true;
      } else {
        this.codigosError = [];
        this.showValidationError = false;
      }
    },

    validate() {
      const hasTitulo = !!this.titulo && this.titulo.trim().length > 0;
      if (!hasTitulo) {
        return false;
      }

      const hasCodigos = !!this.codigosObra && this.codigosObra.trim().length > 0;
      
      if (!hasCodigos) {
        this.validateCodigos();
        return false;
      }

      this.showValidationError = false;
      this.codigosError = [];
      return true;
    }
  }
};

</script>

